export default class ShareScreen {
  constructor(container, scope) {
    this.scope = scope;
    this.container = container;
    this.loader = this.container.querySelector(".bubble-loader");
    this.button = this.container.getElementsByTagName("button")[0];
    this.wrapper = this.container.querySelector(".share-wrapper");
    this.handler = {
      click: this.onClick.bind(this),
    };
    this.button.addEventListener("click", this.handler.click);
  }

  set image(image) {
    const img = document.querySelector("#shared_image");
    img.onload = () => {
      this.loader.classList.add("hidden");
    };
    img.src = image;
  }

  show() {
    this.container.classList.remove("hidden");
    this.wrapper.classList.add("bounceInUp");
  }

  hide() {
    this.container.classList.add("hidden");
  }

  onClick() {
    this.scope.startIntro();
    this.hide();
  }
}
